
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $aacbf8ada7f84364$exports = {};

$parcel$export($aacbf8ada7f84364$exports, "spectrum--lightest", function () { return $aacbf8ada7f84364$export$baaa804dc80cce18; }, function (v) { return $aacbf8ada7f84364$export$baaa804dc80cce18 = v; });
var $aacbf8ada7f84364$export$baaa804dc80cce18;
$aacbf8ada7f84364$export$baaa804dc80cce18 = `EV5Q3q_spectrum--lightest`;


export {$aacbf8ada7f84364$exports as default};
//# sourceMappingURL=vars_spectrum-lightest_css.mjs.map
